import React from "react";
import { FUNNEL_OPTIONS } from "@/lib/funnelOptions";

const INPUT = "w-full border-2 border-black px-2 py-1.5 text-sm bg-white";
const money = (n) => `$${Number(n).toLocaleString(undefined, { maximumFractionDigits: 2 })}`;

export const BuyerPriceFields = ({ data, form, set }) => {
  const { range, has_delivery: hasDelivery } = data.price;
  const varies = range && range.min !== range.max;
  const setFunnel = (slug, v) => set("funnel_prices", { ...form.funnel_prices, [slug]: v });
  return (
    <div data-testid="buyer-funnels-prices">
      <label className="label-mono block">Selling price per lead (USD)
        <input type="number" min="1" step="1" className={`${INPUT} mt-1`} value={form.price} disabled={!hasDelivery}
               placeholder={varies ? `${money(range.min)}\u2013${money(range.max)} by state` : "e.g. 400"}
               onChange={(e) => set("price", e.target.value)} data-testid="buyer-funnels-price" />
      </label>
      <div className="mt-1 text-[10.5px] text-zinc-600">
        {!hasDelivery && "Set up this buyer's delivery first to price their leads. "}
        {varies && "Prices differ by state today; entering a price sets the same price for every state. "}
        Used for the buyer&apos;s spend and invoices.
      </div>
      <div className="label-mono mt-4 mb-1">Price per funnel (optional)</div>
      <div className="text-[10.5px] text-zinc-600 mb-2">Leave blank to use the selling price above.</div>
      <div className="flex flex-col gap-1.5">
        {FUNNEL_OPTIONS.map((f) => (
          <label key={f.slug} className="grid grid-cols-[1fr_110px] items-center gap-2 text-[11px]">
            <span className={form.picks.includes(f.slug) ? "" : "text-zinc-400"}>{f.title}</span>
            <input type="number" min="1" step="1" className={INPUT} value={form.funnel_prices[f.slug] || ""}
                   placeholder="Same" onChange={(e) => setFunnel(f.slug, e.target.value)}
                   data-testid={`buyer-funnels-price-${f.slug}`} />
          </label>
        ))}
      </div>
    </div>
  );
};
